import { statuses_ } from "..";
import Dropdown from "../../../Dropdown";
import styles from "./Requested.module.sass";
import cn from "classnames";
import Loader from "../../../Loader";
import TextInput from "../../../TextInput";
import Disclaimer from "../../../Disclaimer";
import nft_product from "../../../../i11/Nft_Product";
import { useUser } from "../../../../context";

const statuses = ["REDEEM_APPROVED", "REDEEM_DECLINED"];

const RequestedPage = ({ body, setBody, update_, isLoading, item }) => {
	const { locale } = useUser();
	return (
		<div className={styles.container}>
			<div className="body1-m">{nft_product[locale].requested1}</div>
			{item.redeemStatus === "REDEEM_RECEIVED" && (
				<>
					<Disclaimer className={styles.disclaimer}>
						<div className="body1-m">{nft_product[locale].requested2}</div>
						<div className={styles.flex1}>
							<div>{nft_product[locale].status}</div>
							<div className={styles.REDEEM_RECEIVED}>
								{nft_product[locale].received}
							</div>
						</div>
					</Disclaimer>
					<div className="body1-m">{nft_product[locale].next}</div>
				</>
			)}
			{"REDEEM_DECLINED" === body.status && (
				<>
					<Disclaimer className={styles.disclaimer}>
						{nft_product[locale].requested3}
					</Disclaimer>
					<TextInput
						defaultValue={body.note}
						placeHolder={nft_product[locale].req_place_holder}
						type="text"
						textarea
						onChangeInput={(e) =>
							setBody((p) => {
								return { ...p, note: e };
							})
						}
					/>
				</>
			)}
			<div className={styles.flex}>
				{item.redeemStatus === "REDEEM_REQUESTED" ? (
					<button
						onClick={update_}
						className={cn("button", {
							disabled: isLoading,
						})}
					>
						{isLoading && <Loader />}
						{nft_product[locale].receive_req}
					</button>
				) : (
					<>
						<Dropdown
							tooltip={nft_product[locale].req_tooltip}
							value={body.status}
							setValue={(status) =>
								setBody((p) => {
									return { ...p, status };
								})
							}
							options={statuses}
							dictionary={statuses_}
						/>
						<button
							onClick={update_}
							className={cn("button", {
								disabled: isLoading,
							})}
						>
							{isLoading && <Loader />}
							{nft_product[locale].submit}
						</button>
					</>
				)}
			</div>
		</div>
	);
};

export default RequestedPage;
